import React, { useCallback } from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import { makeStyles, Theme } from '@material-ui/core';

import { FavouriteArchivalEntity } from 'types';
import { ArchivalEntityType, UrlRoute } from 'enums';

function getUrlFromType(
  entityType: ArchivalEntityType,
  entityId: string,
  urlLevel?: number
  //eadId?: string
) {
  let baseUrl = '';

  switch (entityType) {
    case ArchivalEntityType.ARCHIVAL_AID:
      baseUrl = `${UrlRoute.ARCHIVAL_AID}/0`;
      break;
    case ArchivalEntityType.ARCHIVAL_COLLECTION:
      baseUrl = `${UrlRoute.ARCHIVAL_COLLECTION}/0`;
      break;
    case ArchivalEntityType.ARCHIVAL_UNIT:
      baseUrl = `${UrlRoute.ARCHIVAL_AID}/${urlLevel ?? 1}`;
      break;
    case ArchivalEntityType.EAD_NODE:
      baseUrl = `${UrlRoute.ARCHIVAL_AID}/${urlLevel ?? 1}`;
      break;
  }

  const urlId = entityId;
  const eadSuffix = entityType === ArchivalEntityType.EAD_NODE ? '/ead' : '';

  return `${baseUrl}/${urlId}${eadSuffix}`;
}

const useStyles = makeStyles((theme: Theme) => ({
  favouriteLabel: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginBottom: '8px !important',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}));

export function FavouriteDetailCell({
  data,
  allData,
}: {
  data: string;
  allData: FavouriteArchivalEntity;
}) {
  const classes = useStyles();

  const { archivalEntityType, entityId, urlLevel } = allData;

  const handleLinkAisObject = useCallback(
    (url: string) => () => {
      window.open(process.env.PUBLIC_URL + url, '_blank');
    },
    []
  );

  const detailUrl = getUrlFromType(archivalEntityType, entityId, urlLevel);

  return (
    <Typography
      title={data}
      component="div"
      variant="body2"
      className={classes.favouriteLabel}
      onClick={handleLinkAisObject(detailUrl)}
    >
      {data}
    </Typography>
  );
}
